export default __webpack_public_path__ + "static/media/aws-cloudfront.27caf2b0.svg";